/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTrayModule } from './cable-tray.module';
export { CableTrayComponent } from './cable-tray.component';